module.exports = __webpack_public_path__ + "static/red_dragon_exales_flame-5d2d3a233abbfa688ad5af81985f825e.png";